<template>
    <div class="explain">
        <div class="panel">
            <v-slider ref="slider" autoplay pauseOnHover @userHasInteracted="userHasInteracted">
                <div>
                    <div class="slider-content" @mouseleave="onMouseLeave" @mouseenter="onMouseEnter">
                        <h2>Hoe werkt <br/>Lotto&rsquo;s Ballenbak?</h2>
                        <img class="visual" src="/static/img/explain/1.jpg" />
                        <h3>Snel klikken</h3>
                        <p>Klik zo snel mogelijk de Lotto ballen weg <br/>om alle cadeautjes aan te kunnen klikken.</p>
                    </div>
                </div>
                <div>
                    <div class="slider-content" @mouseleave="onMouseLeave" @mouseenter="onMouseEnter">
                        <h2>Hoe werkt <br/>Lotto&rsquo;s Ballenbak?</h2>
                        <img class="visual" src="/static/img/explain/2.jpg" />
                        <h3>Cadeautjes</h3>
                        <p>Tussen de Lotto ballen zitten 5 cadeautjes verstopt. <br/>Ieder cadeautje is maar liefst &euro;900 waard.</p>
                    </div>
                </div>
                <div>
                    <div class="slider-content" @mouseleave="onMouseLeave" @mouseenter="onMouseEnter">
                        <h2>Hoe werkt <br/>Lotto&rsquo;s Ballenbak?</h2>
                        <img class="visual" src="/static/img/explain/3.jpg" />
                        <h3>De bom</h3>
                        <p>Pas op de bom! Tik je deze aan dan gaan er 5 seconden van je tijd af.</p>
                    </div>
                </div>
                <div>
                    <div class="slider-content" @mouseleave="onMouseLeave" @mouseenter="onMouseEnter">
                        <h2>Hoe werkt <br/>Lotto&rsquo;s Ballenbak?</h2>
                        <img class="visual" src="/static/img/explain/4.jpg" />
                        <h3>Pas op! Vuurbal!</h3>
                        <p>Klik niet op de vuurbal! Deze verbrandt &euro;100 <br/>van je bij elkaar gespeelde bedrag.</p>
                    </div>
                </div>
                <div>
                    <div class="slider-content" @mouseleave="onMouseLeave" @mouseenter="onMouseEnter">
                        <h2>Hoe werkt <br/>Lotto&rsquo;s Ballenbak?</h2>
                        <img class="visual" src="/static/img/explain/5.jpg" />
                        <h3>Einde spel</h3>
                        <p>Het spel is afgelopen als je alle cadeautjes hebt gevonden of als de tijd op is. Dus&nbsp;speel&nbsp;snel!</p>
                    </div>
                </div>
            </v-slider>

            <!-- <v-slider ref="slider" autoplay pauseOnHover v-else @userHasInteracted="userHasInteracted">
                <div>
                    <div class="slider-content" @mouseleave="onMouseLeave" @mouseenter="onMouseEnter">
                        <img class="visual" src="/static/img/explain/1.jpg" />
                        <h2>Snel klikken</h2>
                        <p>Klik zo snel mogelijk de <br/>Lotto ballen weg om alle <br/>cadeautjes te vinden</p>
                        <button :class="{ 'hidden': !showPlayButton }" @click="toGame">Spelen</button>
                    </div>
                </div>
                <div>
                    <div class="slider-content" @mouseleave="onMouseLeave" @mouseenter="onMouseEnter">
                        <img class="visual" src="/static/img/explain/2.jpg" />
                        <h2>Cadeautjes</h2>
                        <p>Tussen de Lotto ballen zitten <br/>5 cadeautjes verstopt. Ieder cadeautje <br/>is maar liefst &euro;900 waard.</p>
                        <button :class="{ 'hidden': !showPlayButton }" @click="toGame">Spelen</button>
                    </div>
                </div>
                <div>
                    <div class="slider-content" @mouseleave="onMouseLeave" @mouseenter="onMouseEnter">
                        <img class="visual" src="/static/img/explain/3.jpg" />
                        <h2>Kerstbal</h2>
                        <p>Pas op de kerstbal! Tik je <br/>deze kapot dan gaan er <br/>5 seconden van je tijd af.</p>
                        <button :class="{ 'hidden': !showPlayButton }" @click="toGame">Spelen</button>
                    </div>
                </div>
                <div>
                    <div class="slider-content" @mouseleave="onMouseLeave" @mouseenter="onMouseEnter">
                        <img class="visual" src="/static/img/explain/4.jpg" />
                        <h2>Pas op! Sneeuwbal!</h2>
                        <p>Klik niet op de sneeuwbal! <br/>Deze haalt &euro;100 van je <br/>bij elkaar gespeelde bedrag af.</p>
                        <button :class="{ 'hidden': !showPlayButton }" @click="toGame">Spelen</button>
                    </div>
                </div>
                <div>
                    <div class="slider-content" @mouseleave="onMouseLeave" @mouseenter="onMouseEnter">
                        <img class="visual" src="/static/img/explain/5.jpg" />
                        <h2>Einde spel</h2>
                        <p>Het spel is afgelopen als <br/>je alle cadeautjes hebt gevonden <br/>of als de tijd op is. Dus speel snel!</p>
                        <button :class="{ 'hidden': !showPlayButton }" @click="toGame">Spelen</button>
                    </div>
                </div>
            </v-slider> -->
        </div>
        <router-link tag="button" class="red continue-button" to="/spel" >Speel nu</router-link>
    </div>
</template>

<style lang="scss" scoped>
    .panel{
        overflow:hidden;
    }
</style>

<script>
    import { TimelineMax, TweenMax } from '@/vendor';
    import Slider from '@/app/components/Slider';
    import { tracking } from '@/app/mixins';

    export default {
        components: {
            'v-slider': Slider
        },

        mixins: [ tracking ],

        data()
        {
            return {
                showPlayButton: false
            };
        },

        computed: {
            isVersion2()
            {
                return this.$store.getters.isVersion2;
            }
        },

        methods: {
            toGame( e )
            {
                this.trackEvent( 'Klik op button - Spelen', 'Link tracking', window.location.origin + '/spel' );
                this.$router.replace( '/spel' );
            },

            onMouseLeave( e )
            {
                if( this.$refs.slider )
                {
                    this.$refs.slider.onMouseLeave( e );
                }
            },

            onMouseEnter( e )
            {
                if( this.$refs.slider )
                {
                    this.$refs.slider.onMouseEnter( e );
                }
            },

            userHasInteracted()
            {
                this.showPlayButton = true;
                TweenMax.fromTo( '.slider-content button', 0.3, { autoAlpha: 0, height: 0 }, { autoAlpha: 1, height: 'auto' });
            },

            getAnimateIn()
            {
                let tl = new TimelineMax();

                TweenMax.set( '.explain > .panel > div', { autoAlpha: 0 });

                tl.from( '.explain > .panel', 0.5, { y: '200%', ease: Sine.easeOut });
                tl.fromTo( '.explain > .panel', 0.5, { width: '5px', minWidth: '5px' }, { width: '500px', minWidth: '0px' });
                tl.to( '.explain > .panel > div', 0.6, { autoAlpha: 1 }, 0.8 );

                // tl.from( '.slider-content', 0.3, { autoAlpha: 0 }, 5 );

                tl.from( '.explain .continue-button', 0.3, { autoAlpha: 0 }, 1 );

                return tl;
            },

            getAnimateOut()
            {
                let tl = new TimelineMax();
                tl.fromTo( '.explain > .panel', 0.5, { maxWidth: window.innerWidth + 'px' }, { maxWidth: '5px', ease: Sine.easeOut });
                tl.to( '.explain > .panel', 0.5, { y: '-200%' });
                tl.to( '.explain > .panel > div', 0.2, { autoAlph: 0 }, 0 );
                tl.to( '.explain', 0.5, { autoAlpha: 0 });
                tl.to( '.explain .continue-button', 0.3, { autoAlpha: 0 }, 0 );

                return tl;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/pages/Explain.vue